import { api, getData, postData } from './request';
import type {
  PricingChange,
  PricingChangeStatus,
} from '@cutr/constants/pricing-change';

export function getPricingChangesForVariant(
  variantId: string,
  signal?: AbortSignal
) {
  return getData<PricingChange[]>(
    `/v2/order-variants/${variantId}/pricing-changes`,
    {
      signal,
    }
  );
}

export function createPricingChange(payload: PricingChange) {
  return postData<PricingChange>('/v2/pricing-changes', payload);
}

export function updatePricingChange(id: string, payload: PricingChange) {
  return postData<PricingChange>(`/v2/pricing-changes/${id}`, payload);
}

// Response is an UNSAVED entity (no id, no label, no timestamps) — a preview
// only, never write it into the query cache.
export function previewPricingChange(
  payload: PricingChange,
  signal?: AbortSignal
) {
  return postData<PricingChange>('/v2/pricing-changes?preview=true', payload, {
    signal,
  });
}

// The server can split the change on accept and answer with either a single
// PricingChange or `{ accepted, declined }`.
export async function setPricingChangeStatus(
  id: string,
  status: PricingChangeStatus,
  payload?: { declinedReason?: string }
): Promise<void> {
  await api.post(`/v2/pricing-changes/${id}/${status}`, payload ?? {});
}

// Same either-shape response as setPricingChangeStatus (see comment above).
export async function reviewPricingChange(
  id: string,
  payload: {
    acceptedItemIds: string[];
    declinedItems: { id: string; declinedReason: string }[];
  }
): Promise<void> {
  await api.post(`/v2/pricing-changes/${id}/review`, payload);
}

export async function deletePricingChange(id: string): Promise<void> {
  await api.delete(`/v2/pricing-changes/${id}`);
}
